import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { TARGET_TYPE } from '../utils/target-scope.utils';

const KNOWN_TARGET_TYPES = new Set<string>(Object.values(TARGET_TYPE));

export function toConversationTargetType(
  value: string | null | undefined,
): TargetTypeType | undefined {
  return value && KNOWN_TARGET_TYPES.has(value)
    ? (value as TargetTypeType)
    : undefined;
}

export function isTenantScopedConversation({
  targetId,
  threadId,
}: {
  targetId?: string | null;
  threadId: string;
}): boolean {
  return !targetId || targetId === threadId;
}

export function conversationTabTargetFields({
  conversation,
  currentTargetId,
  currentTargetType,
}: {
  conversation: {
    targetId?: string | null;
    targetType?: string | null;
    threadId: string;
  };
  currentTargetId?: string;
  currentTargetType?: TargetTypeType;
}): {
  targetId?: string;
  targetType?: TargetTypeType;
} {
  if (isTenantScopedConversation(conversation)) {
    return {};
  }

  return {
    targetId: conversation.targetId ?? currentTargetId,
    targetType:
      toConversationTargetType(conversation.targetType) ?? currentTargetType,
  };
}
